import React from "react"
import { Router, Route } from "react-router-dom"
import TransitionGroup from "react-transition-group/CSSTransitionGroup"
import { connect } from "react-redux"
import qs from "query-string"

import { CookieBannerContainer } from "buoy-bottom-banner"
import PostIntent from "./feedback/components/postIntent"
import Nav from "./nav"

import { IS_PRODUCTION } from "./common/constants"
import history from "./history"
import * as authActions from "./auth/actions"

import ChatList from "./interview/components/ChatList"
import Response from "./interview/components/Response"
import * as actions from "./interview/actions"
import { initSimpleFlow } from "./simpleFlow/actions"
import { coronavirusSearch } from "./integration/utils"
import { takeSnapshot } from "./redux/actions"

import DeleteConfirmModal from "./modals/DeleteConfirmModal"
import EditConfirmModal from "./modals/EditConfirmModal"
import ErrorModal from "./modals/ErrorModal"
import ExplanationModal from "./modals/ExplanationModal"
import InfantExplanationModal from "./modals/InfantExplanationModal"
import MessageConfirmModal from "./modals/MessageConfirmModal"
import PictureModal from "./modals/PictureModal"
import QuestionFeedbackModal from "./modals/QuestionFeedbackModal"
import TermModal from "./modals/TermModal"
import GinaModal from "./modals/GinaModal"
import ProfileInterestModal from "./modals/ProfileInterestSuccessModal"

import Activation from "./auth/components/AccountActivation"
import Dashboard from "./dashboard"
import DemoDashboard from "./dashboard/components/DemoDashboard"
import Login from "./auth/components/LoginPage"
import PasswordReset from "./auth/components/ResetPassSwitch"
import PaymentFlow from "./payment/components"
import Profile from "./account/components/Profile"
import Signup from "./auth/components/SignupSwitch"
import LoadingScreen from "./common/components/LoadingScreen"
import Unavailable from "./common/components/Unavailable"
import Dev from "./dev/components/Dev"
import TeleMedicineForm from "./payment/components/TeleMedicineForm"
import TelemedicineModal from "./payment/components/TelemedicineModal"
import "./styles/main.scss"


const App = props => (
  <div>
    <div className="master-container col-xs-12">
      <div className="row">
        <ChatList {...props} />
        <Response {...props} />
        <LoadingScreen {...props} />
        <EditConfirmModal />
        <DeleteConfirmModal />
        <QuestionFeedbackModal {...props} />
        <ExplanationModal />
        <InfantExplanationModal />
        <PictureModal />
        <TermModal />
        <GinaModal />
        <ErrorModal />
        <MessageConfirmModal />
        <ProfileInterestModal />
        <PostIntent />
        <TelemedicineModal />
        <TransitionGroup
          transitionName="modal"
          transitionEnterTimeout={1000}
          transitionLeaveTimeout={500}
        />
      </div>
    </div>
  </div>
)

class AppContainer extends React.Component {
  componentDidMount() {
    if (!this.props.completed) {
      window.scrollTo({ top: 0, behavior: "smooth" })
    } else {
      const questions = document.querySelectorAll("div.bubble-question")
      questions[questions.length - 1].scrollIntoView({ behavior: "smooth" })
    }
    if (this.props.startPageTracker && this.props.exitPageTracker) {
      this.props.startPageTracker()
      this.props.exitPageTracker()
    }
  }

  render() {
    return <App {...this.props} {...this.state} />
  }
}

const mapStateToProps = state => ({
  flaggedQuestion: state.feedback.flaggedQuestion,
  unflaggedQuestion: state.feedback.unflaggedQuestion,
  flagFeedback: state.feedback.flagFeedback,
  explanation: state.feedback.explanation,
  completed: state.completion.completed,
  brandConfigs: state.brand,
  loggedIn: state.auth.status.login.status,
  // these two are for signup alert a/b test
  searchActive: state.search.active,
  diagConcern: state.feedback.diagnosisConcern,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  startPageTracker: actions.startPageTracker(),
  exitPageTracker: actions.exitPageTracker(),
  initSimpleFlow: concern => dispatch(initSimpleFlow(concern)),
})

const AppWrapper = connect(mapStateToProps, mapDispatchToProps)(AppContainer)

class AppRouter extends React.Component {
  onCloseCookieBanner = () => {
    this.props.submitViewedCookiePolicy(true)
  }

  render() {
    let showCookieBanner = this.props.viewedCookiePolicy === false
    let bannerOverlay = false
    let bannerClosable = true
    let onBannerClick = this.onCloseCookieBanner


    const isLocal = window.location.hostname === "localhost"
    const isNYT = window.location.href.includes("nyt.")
    const isHoustonMethodist = window.location.href.includes(
      "houstonmethodist."
    )
    const isDash = window.location.pathname === "/dashboard/"
    const shouldRedirect = !isLocal && !isNYT && !isHoustonMethodist && isDash

    // Hacky redirect away from /dashboard/ for non-NYT users,
    // to be removed when Dashboard is publically released
    if (typeof window !== "undefined" && shouldRedirect) {
      window.location.replace("/symptom-checker/")
    }

    return (
      <Router history={history}>
        <React.Fragment>
          <Nav />
          <Route component={AppWrapper} exact path="/" />
          <Route component={AppWrapper} path="/symptom-checker/" />
          <Route component={Login} path="/login" />
          <Route component={Signup} path="/signup" />
          <Route component={Activation} path="/activated" />
          <Route component={PasswordReset} path="/reset" />
          <Route component={AppContainer} path="/quiz/*" />
          <Route component={Unavailable} path="/unavailable" />
          <Route component={PaymentFlow} path="/pay" />
          <Route component={TeleMedicineForm} path="/telemedicine/" />
          <Route component={Profile} path="/profile" />
          <Route component={Dashboard} path="/dashboard" />
          <Route component={Dev} path="/dev-mode/" />
          <Route component={DemoDashboard} path="/demo/" />

          {showCookieBanner &&
            this.props.brandConfigs &&
            this.props.brandConfigs.name === "public" && (
              <CookieBannerContainer
                prod={IS_PRODUCTION}
                overlay={bannerOverlay}
                closeable={bannerClosable}
                onClick={onBannerClick}
              />
            )}
        </React.Fragment>
      </Router>
    )
  }
}

class RouterContainer extends React.Component {
  componentDidMount() {
    // TODO: make this more flexible for future flows (more query params e.g concern and type)
    const { concern, brand, configuration } = qs.parse(window.location.search)
    // TODO: CORONAVIRUS TECH DEBT, remove the coronavirusSearch replace with just concern in the future
    // validation to make sure if this is allowed
    if (coronavirusSearch(concern)) {
      if (concern !== "coronavirus") {
        // TODO: CORONAVIRUS TECH DEBT, remove this redirect, here for sharability reasons
        // redirect user to the correct coronavirus url if they misspell the term
        // this will remove any URL param that’s not brand or configuration
        let redirectUrl = "/symptom-checker/?concern=coronavirus"
        if (brand) {
          redirectUrl = `${redirectUrl}&brand=${brand}`
        } else if (configuration) {
          redirectUrl = `${redirectUrl}&configuration=${configuration}`
        }

        history.replace(redirectUrl)
      }
      this.props.initSimpleFlow(concern)
    }

    this.props.getInitInfo().then(() => {
      // take snapshot after app initialization is complete for use with startOver()
      takeSnapshot("init")
    })
  }

  render() {
    return <AppRouter {...this.props} />
  }
}

RouterContainer = connect(
  state => ({
    viewedCookiePolicy: state.auth.viewedCookiePolicy,
    brand: state.brand,
  }),
  {
    ...authActions,
    initSimpleFlow,
  }
)(RouterContainer)

export { RouterContainer as default, AppContainer as App }



// WEBPACK FOOTER //
// ./assets/app.js